export default "__VITE_ASSET__D_V3jEa4__"